import type { ReactNode } from "react";

import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@krea/shared/design-system/Card";

export const LenderProfileSectionCard = ({
  title,
  description,
  right,
  children,
}: {
  title: string;
  description?: string;
  right?: ReactNode;
  children: ReactNode;
}) => {
  return (
    <Card className="rounded-xl border border-gray-200 shadow-sm">
      <CardHeader className="flex flex-row items-start justify-between gap-4 border-b border-gray-200">
        <div>
          <CardTitle className="text-xl">{title}</CardTitle>
          {description ? (
            <p className="mt-1 text-sm text-gray-500">{description}</p>
          ) : null}
        </div>
        {right}
      </CardHeader>
      <CardContent className="p-8">{children}</CardContent>
    </Card>
  );
};
